"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vaultAddress = exports.voterAddress = exports.voterWeightRecordAddress = exports.registrarAddress = exports.VsrClient = exports.MNDE_VSR_PROGRAM_ID = void 0;
const web3_js_1 = require("@solana/web3.js");
const VsrClientIdl_1 = require("./VsrClientIdl");
const utf8_1 = require("@project-serum/anchor/dist/cjs/utils/bytes/utf8");
const anchor_1 = require("@project-serum/anchor");
const solana_spl_token_modern_1 = require("solana-spl-token-modern");
exports.MNDE_VSR_PROGRAM_ID = new web3_js_1.PublicKey('VoteMBhDCqGLRgYpp9o7DGyq81KNmwjXQRAHStjtJsS');
class VsrClient {
    constructor(program) {
        this.program = program;
    }
    static async connect(provider, programId = exports.MNDE_VSR_PROGRAM_ID) {
        const anchorProvider = new anchor_1.AnchorProvider(provider.connection, provider.wallet, provider.opts);
        const idl = VsrClientIdl_1.IDL;
        return new VsrClient(new anchor_1.Program(idl, programId, anchorProvider));
    }
}
exports.VsrClient = VsrClient;
// [realm.key().as_ref(), b"registrar".as_ref(), realm_governing_token_mint.key().as_ref()]
function registrarAddress({ programId, realm, mint, }) {
    return web3_js_1.PublicKey.findProgramAddressSync([realm.toBytes(), (0, utf8_1.encode)('registrar'), mint.toBytes()], programId);
}
exports.registrarAddress = registrarAddress;
// [registrar.key().as_ref(), b"voter-weight-record".as_ref(), voter_authority.key().as_ref()]
function voterWeightRecordAddress({ programId, registrar, voterAuthority, }) {
    return web3_js_1.PublicKey.findProgramAddressSync([
        registrar.toBytes(),
        (0, utf8_1.encode)('voter-weight-record'),
        voterAuthority.toBytes(),
    ], programId);
}
exports.voterWeightRecordAddress = voterWeightRecordAddress;
// [registrar.key().as_ref(), b"voter".as_ref(), voter_authority.key().as_ref()]
function voterAddress({ programId, registrar, voterAuthority, }) {
    return web3_js_1.PublicKey.findProgramAddressSync([registrar.toBytes(), (0, utf8_1.encode)('voter'), voterAuthority.toBytes()], programId);
}
exports.voterAddress = voterAddress;
function vaultAddress({ voter, mint, }) {
    return (0, solana_spl_token_modern_1.getAssociatedTokenAddressSync)(mint, voter, true);
}
exports.vaultAddress = vaultAddress;
//# sourceMappingURL=VsrClient.js.map